import TextStyling from './RentGuarantee/TextStyling';

export const FeatureLaunchNotification = ({
  title = '',
  description = '',
  ctaText = '',
  url = '',
  name = '',
  icon = '',
  v10Icon = '',
} = {}) => ({
  title: String(title),
  description: String(description),
  ctaText: String(ctaText),
  url: String(url),
  name: String(name),
  icon: String(icon),
  v10Icon: String(v10Icon),
});

const NotificationBanner = ({ bannerId = '', bannerType = '', notificationText = [] } = {}) => ({
  bannerId: String(bannerId),
  bannerType: String(bannerType),
  notificationText: notificationText.map((item) => TextStyling(item)),
});

export default NotificationBanner;

export type NotificationBannerType = ReturnType<typeof NotificationBanner>;
